export var Chunk;
(function (Chunk) {
    Chunk[Chunk["MTHD"] = 1297377380] = "MTHD";
    Chunk[Chunk["MTRK"] = 1297379947] = "MTRK";
})(Chunk || (Chunk = {}));
